export default __webpack_public_path__ + "static/media/anthology-top.8f34e3bf.png";